export const EVENT_BUS_SESSION_CUSTOM_VIEW_UPDATE = 'gd.session:custom-view-update'